module.exports = __webpack_public_path__ + "static/media/Up Arrow.57cfb96c.svg";